import { render, staticRenderFns } from "./PatientMedicalCaseForm.vue?vue&type=template&id=c7aff52e&scoped=true"
import script from "./PatientMedicalCaseForm.vue?vue&type=script&lang=js"
export * from "./PatientMedicalCaseForm.vue?vue&type=script&lang=js"
import style0 from "./PatientMedicalCaseForm.vue?vue&type=style&index=0&id=c7aff52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aff52e",
  null
  
)

export default component.exports